import React from 'react';
import PropTypes from 'prop-types';
import { dataAttribsForEl, formatClassName } from '../../Util';
import Icon from '../Icon';

const CardTitle = ({ children, className, icon, size, iconSize, titleDataAttributes: { context, optionalAttributes } }) => {
  const getClasses = () => formatClassName([
    'card-title',
    `card-title-${size}`,
    className
  ]);

  const dataAttributes = dataAttribsForEl(context, optionalAttributes);

  return (
    <span className={getClasses()} {...dataAttributes}>
      {icon && <Icon iconType={icon} size={iconSize} additionalClasses="title-icon" />}
      {children}
    </span>
  );
};

CardTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  size: PropTypes.oneOf([14, 16, 18]),
  titleDataAttributes: PropTypes.shape({
    context: PropTypes.object,
    optionalAttributes: PropTypes.object
  })
};

CardTitle.defaultProps = {
  iconSize: 'medium',
  titleDataAttributes: {}
}

export default CardTitle;
